import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient} from '@angular/common/http';
import {environment as env} from '../../environments/environment';
import {LanguageService} from '../services/language.service';
import { ProductSearchComponent } from '../products/product-search/product-search.component';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  formGroup;
  errorMsg:string;
  errorMsg_ar:string;
  sucessMsg:string;
  sucessMsg_ar:string;
  showLang:string;

  constructor(public translate: TranslateService, 
     private http:HttpClient,
     private langObj:LanguageService,
     private formBuilder: FormBuilder) { 
    
    this.langObj.langStr.subscribe((data)=>{
      this.showLang = data;
    });

    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      number: ['', Validators.required],
      subject: ['', Validators.required],
      message: ['', Validators.required],
    });

  }

  ngOnInit(): void {
    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }
    console.log(this.showLang);
  }

  onSubmit() {
    
    if(this.formGroup.invalid){
      this.errorMsg = "All fields are required";
      this.errorMsg_ar = "جميع الحقول مطلوبة";
    }else{
      var name = this.formGroup.value.name;
      var email = this.formGroup.value.email;
      var number = this.formGroup.value.number;
      var subject = this.formGroup.value.subject;
      var message = this.formGroup.value.message;
      
      this.http.post(env.apiurl+'contact-us',{
        'name': name,
        'email': email,
        'phone': number,
        'subject': subject,
        'message': message
      }).subscribe(rawData=>{
  
      if (rawData['success'] == true){
        this.sucessMsg = "Your query has been submitted successfully.";
        this.sucessMsg_ar = "تم تقديم استفسارك بنجاح";
        this.errorMsg ='';
        this.errorMsg_ar ='';
        this.formGroup.reset();
      }else{
        this.errorMsg = rawData['message'];
        this.errorMsg_ar = rawData['message_ar'];
        this.sucessMsg ='';
        this.sucessMsg_ar ='';
      }
      });


    }

  }


}
